import { Injectable, Component, OnInit, ViewContainerRef, Renderer2 } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Router} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {Subscription} from 'rxjs';
import { IMyDpOptions } from 'mydatepicker';

import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';
import { EchexpaymentService } from '../echexpayment.service';
import { Helper } from '../helpers/helper';
import { Constants } from '../app.constants';

class DataTablesResponse {
	data: any[];
	draw: number;
	recordsFiltered: number;
	recordsTotal: number;
}

@Component({
  selector: 'echexpayment-activitylog',
  templateUrl: './activitylog.component.html',
  styleUrls: ['./activitylog.component.css']
})
export class ActivitylogComponent implements OnInit {
	busy:Subscription;
	public data:{};
	public token:string;
	public _id:string;
	public filterQuery = "";
    public rowsOnPage = 10;
    public sortBy = "created_at";
    public sortOrder = "asc";
	public dataNotFound: boolean=false;
	public advancedata: any = {};
	public advanceFilterdata: any = {
        Customfilter: '',
        Selectfilter: '',
        Entryfilter: '',
        Recuringfilter: ''
    };
	public DateValidate: string;
	public myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
        editableDateField: false
    };
    public user_token: string;
    public id: string;
	private actionUrl: string;
	public merchantUserTransaction: {};
    public merchantTransaction: {};

	constructor(private userService: UserService, private renderer : Renderer2, private toastr: ToastrService, private router: Router, private localStorageService: LocalstorageService, private http: HttpClient, private _constants: Constants, protected echexpaymentService: EchexpaymentService) { 
		this.actionUrl = _constants.ServerWithApiUrl;
		var currentUser = this.localStorageService.getData("currentUserToken");
		this.token =  currentUser.data.user_token;
	    let userDetails = this.localStorageService.getData("currentUser");
        this._id = userDetails._id;
		this.id = userDetails._id;
		
	}

	ngOnInit() {
		this.getAllMerchantForDropDown();
		this.getAllTransactionAdvance();
	}

	getAllMerchantForDropDown() {
        var data = {
            user_token: this.token,
            token: this.id,
            _id: this.id
        }
        let responseData = < any > {};
        this.echexpaymentService.getAllMerchantForDropDownApi(data).subscribe(
            response => {
                responseData = response;
                this.merchantTransaction = responseData.data
            },
            error => {
                responseData = error;
                this.toastr.error(responseData.error.message, 'Failed!');
            }
        );
    }

	// Get activity log
	getActivityList() {
		var data = {
		  token: this.token,
		  _id: this._id,
		}
		let responseData = <any>{};
		this.busy =  this.userService.getActivityList(data).subscribe(
		   response => {
		    responseData = response;
			this.data = responseData.data;
			if(responseData.data.length == 0){
				this.dataNotFound =  responseData.message
			}
		   },
		   error => {
			responseData = error;
			this.toastr.error(responseData.error.message, 'Failed!');
		  }
		);
	}

	clearDate() {
        this.DateValidate = "";
        this.advancedata.from_date = '';
        this.advancedata.to_date = '';
        this.getAllTransactionAdvance();
    }

	// get transcation data for advanced tab
    getAllTransactionAdvance(model: any = {}, search_but: any = '') {
        this.dataNotFound = false;
        model.echex_merchant_token = this.advancedata.echex_merchant_token;

        if (search_but === 1) {
            //date validate
            const fromDate = this.advancedata.from_date && this.advancedata.from_date.jsdate ? new Date(this.advancedata.from_date.jsdate) : null;
            const toDate = this.advancedata.to_date && this.advancedata.to_date.jsdate ? new Date(this.advancedata.to_date.jsdate) : null;
            const currentDate = new Date(); // Get the current date
            currentDate.setHours(0, 0, 0, 0);
            if (fromDate && toDate && fromDate.getTime() === toDate.getTime()) {
                this.DateValidate = "From date and To date cannot be the same.";
                //   return;
            } else if (fromDate && toDate && fromDate > toDate) {
                this.DateValidate = "From date must be less than the To date.";
                return;
            } else if (fromDate && toDate && fromDate == null || toDate == null) {
                this.DateValidate = "For Search Select - From date and To Date";
                return;
            } else {
                this.DateValidate = "";
            }

            if (toDate > currentDate) {
                this.DateValidate = "To date must be less than or equal to the current date.";
                return;
            } else {
                this.DateValidate = "";
            }
        } else if (this.advanceFilterdata.Customfilter) {
            this.advancedata.from_date = '';
            this.advancedata.to_date = '';
        }

        model._id = this.id;
        model.token = this.id;
        model.user_token = this.token;

        if (Object.keys(this.advancedata).length > 0) {
            model.from_date = this.advancedata.from_date && this.advancedata.from_date.formatted;
            model.to_date = this.advancedata.from_date && this.advancedata.to_date.formatted;
        }
    
		var datatable = $('#advance-datatable').DataTable();
		datatable.destroy();

		$('#advance-datatable').DataTable({
			pagingType: 'full_numbers',
			pageLength: 25,
			serverSide: true,
			processing: false,
			destroy: true,
			order: [[0, 'desc']],
			language: {
				searchPlaceholder: "Name,Email,Business,Message..."
			},
			ajax: (dataTablesParameters: any, callback) => {
				var data = {
					user_token: this.token,
					token: this.id,
					_id: this.id
				}

				let params = new URLSearchParams();
				const headers = new HttpHeaders().set('Authorization', `Bearer ${data.user_token}`);  
				let resp_data = < any > {};
				dataTablesParameters = {...dataTablesParameters, ...model};
				this.busy = this.http.post<DataTablesResponse>(
					this.actionUrl +'activitylog/lists/'+data._id,
					dataTablesParameters,
					{headers}
				).subscribe(resp => {
					resp_data = resp.data;
					this.data = resp_data.data;

					callback({
						recordsTotal: resp_data.recordsTotal,
						recordsFiltered: resp_data.recordsFiltered,
						data: []
					});
				});
			},
			columns: [{ data: 'created_at' }, { data: 'business_name' }, { data: 'first_name' },{ data: 'email' },{ data: 'ip_address' }, { data: 'message' }],
			columnDefs: [ {
				'targets': [0], // column index (start from 0)
				'orderable': false, // set orderable false for selected columns
			}]
		});
    }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/activitylog/activitylog.component.ts